// extracted by mini-css-extract-plugin
module.exports = {"mainpage":"_025a50318d--mainpage--3vyA6"};